import {
  DataArray,
  UpdateIconButton,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@compass/core";

import { ListBeProperty } from "components";
import { DistrictListDto, DistrictListResource, Permission, PermissionAction, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { districtPageRoute } from "../DistrictPage/DistrictPage";

export const DistrictTable = (props: {
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  districts: DistrictListDto[];
  setDistricts: (districts: DistrictListDto[]) => void;
  resource: DistrictListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell type="id">
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DistrictListDto>("id"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DistrictListDto>("name"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<DistrictListDto>("schools"))}
                searchFocused={props.searchFocused}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
              />
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.districts.map((districtItem) => (
            <TableRow
              key={districtItem.id}
              onClick={() =>
                navigate(
                  districtPageRoute.getPath({
                    id: districtItem.id,
                    crudMode: "view",
                  })
                )
              }
            >
              <TableCell type="id">{districtItem.id}</TableCell>
              <TableCell>{districtItem.name}</TableCell>
              <TableCell>
                <DataArray value={districtItem.schools} max={3} />
              </TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                    onClick={() =>
                      navigate(
                        districtPageRoute.getPath({
                          id: districtItem.id,
                          crudMode: "edit",
                        })
                      )
                    }
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
